
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FarInfraredHeroSection from './components/FarInfraredHeroSection';
import FarInfraredContentSection from './components/FarInfraredContentSection';

export default function FarInfraredHeat() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <FarInfraredHeroSection />
        <FarInfraredContentSection />
      </main>
      <Footer />
    </div>
  );
}
